export const getTextColor = (isDisable: boolean) => (isDisable ? 'text-minor' : 'text-primary');
